import { Link } from 'react-router-dom';

const LinkButton = ({to, children}) => (
  <Link to={to} className="btn btn-primary d-none d-md-block">{children}</Link>
)

export default LinkButton
